import React from 'react';
import { Image,Nav } from 'react-bootstrap';

const LangToggle = ({ lang, handleLangChange }) => {
  const langOptions = [
    { code: 'en', image: '/images/globe.png' },
    { code: 'ar', image: '/images/flagSaudi.png' },
  ];

  const currentLang = langOptions.find((option) => option.code === lang);
  const nextLang = langOptions.find((option) => option.code !== lang);

  return (
    <Nav.Link>
      <Image alt="image" 
        src={currentLang.image}
        width={20}
        className="rounded-pill img-fluid fit-scale-down"
        onClick={() => handleLangChange(nextLang.code)}
      />
    </Nav.Link>
  );
};

export default LangToggle;